import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/store/cost-center",
        component: List,
        name: "store.cost-center.list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/cost-center/create",
        component: Create,
        name: "store.cost-center.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/cost-center/:id/edit",
        component: Edit,
        name: "store.cost-center.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
